import { type HaveISeenItFlag, type GetFlagResponse } from '../types';
import { HAVE_I_SEEN_IT_URL, DEFAULT_STARGATE_SERVICE_URL } from './common';
import { tryCacheWithClear } from '../utils';
import { fetchJson, postRequest } from './helpers';
const OPEN_INVITE_TYPE = 'open-invite';
const DOMAIN_TYPE = 'domain';
export const PROJECT = 'viral-options-default-to-checked';
export const createHISIDomainFlagKey = (
	product: string,
	cloudId: string,
	domain: string,
): string => {
	return `${cloudId}-${product}-${PROJECT}-${DOMAIN_TYPE}-${domain}`;
};
export const createHISIOpenInviteFlagKey = (product: string, cloudId: string): string => {
	return `${cloudId}-${product}-${PROJECT}-${OPEN_INVITE_TYPE}`;
};

export interface HaveISeenItClientInterface {
	getFlag(flagKey: string): Promise<GetFlagResponse>;
	postFlag(flagKey: string): Promise<void>;
}
export class HaveISeenItClient implements HaveISeenItClientInterface {
	flagsCache: Map<string, HaveISeenItFlag>;
	constructor() {
		this.flagsCache = new Map();
	}
	public clearCache = () => {
		this.flagsCache.clear();
	};
	public async getFlag(flagKey: string): Promise<GetFlagResponse> {
		const cacheValue = this.flagsCache.get(flagKey);
		if (cacheValue) {
			return { response: cacheValue, cached: true };
		}
		const path = `${DEFAULT_STARGATE_SERVICE_URL}${HAVE_I_SEEN_IT_URL}?flagKey=${flagKey}`;
		const response = await fetchJson<HaveISeenItFlag>(path, 'getFlagHISI');
		tryCacheWithClear(this.flagsCache, flagKey, response, 50);
		const returnValue = { response, cached: false };
		return returnValue;
	}

	public async postFlag(flagKey: string): Promise<void> {
		const path = `${DEFAULT_STARGATE_SERVICE_URL}${HAVE_I_SEEN_IT_URL}`;
		await postRequest<string>(path, 'postFlagHISI', { flagKey });
		this.flagsCache.set(flagKey, {
			status: true,
			lastSeenDate: new Date().toISOString(),
		});
	}
}
